import type { IBaseAttributes, TConstraints } from '@feathr/rachis';
import { Collection, Model } from '@feathr/rachis';

interface IGeoFilterAddress {
  city?: string;
  country: string;
  country_code?: string;
  region?: string;
}

export interface IGeoFilter extends IBaseAttributes {
  address: IGeoFilterAddress;
  iso_code?: string;
  kind: 'Country' | 'Region' | 'City' | 'Zip';
  name: string;
}

export class GeoFilter extends Model<IGeoFilter> {
  public readonly className = 'GeoFilter';

  public get constraints(): TConstraints<IGeoFilter> {
    return {};
  }
}

export class GeoFilters extends Collection<GeoFilter> {
  public getClassName(): string {
    return 'geofilters';
  }

  public getModel(attributes: Partial<IGeoFilter>): GeoFilter {
    return new GeoFilter(attributes);
  }
}
